import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={30.561}
      height={30.241}
      viewBox="0 0 30.561 30.241"
      {...props}
    >
      <g transform="translate(-196.274 -249.864)">
        <ellipse
          cx={9.497}
          cy={9.5}
          fill="#f6324b"
          rx={9.497}
          ry={9.5}
          transform="translate(201.505 256.112)"
        />
        <text
          fill="#fff"
          fontFamily="Rubik-Medium, Rubik"
          fontSize={24}
          fontWeight={500}
          transform="rotate(45.97 -212.234 369.015)"
        >
          <tspan x={0} y={0}>
            {'+'}
          </tspan>
        </text>
      </g>
    </svg>
  );
}

export default SvgComponent;
